<template>
    <div class="page-container">
        <el-card class="box-card">
            <el-form :inline="true" :model="queryParams" class="demo-form-inline">
                <el-form-item label="菜单名称">
                    <el-input clearable v-model="queryParams.name" placeholder="请输入菜单名称"></el-input>
                </el-form-item>
                <el-form-item label="状态">
                    <el-select clearable v-model="queryParams.status" placeholder="请选择状态">
                        <el-option label="正常" value="1"></el-option>
                        <el-option label="禁用" value="0"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-button icon="el-icon-search" type="primary" @click="btnSearch">查询</el-button>
                    <el-button icon="el-icon-refresh" @click="btnReset">重置</el-button>
                </el-form-item>
            </el-form>
        </el-card>
        <div style="height: 10px;"></div>

        <el-card class="box-card">
            <el-button type="success" icon="el-icon-plus" @click="handleAdd(null)" size="mini" plain>新增</el-button>
            <div style="height: 10px;"></div>
            <el-table :data="tableData" border style="width: 100%"
                      :tree-props="{children: 'children', hasChildren: 'hasChildren'}"
                      :default-expand-all="isExpandAll"
                      row-key="id">
                <el-table-column prop="name" label="菜单名称" align="center" width="150"></el-table-column>
                <el-table-column prop="icon" label="图标" align="center" width="80">
                    <template slot-scope="scope">
                        <svg-icon v-if="scope.row.icon" :icon="scope.row.icon"></svg-icon>
                        <span v-else>-</span>
                    </template>
                </el-table-column>
                <el-table-column prop="sort" label="排序" align="center" width="80"></el-table-column>
                <!-- 访问路径 -->
                <el-table-column prop="path" label="访问路径" align="center"></el-table-column>
                <!-- 组件路径 -->
                <el-table-column prop="component" label="组件路径" align="center"></el-table-column>
                <!-- 是否缓存 -->
                <el-table-column prop="status" label="状态" align="center">
                    <template slot-scope="scope">
                        <el-tag type="primary" v-if="scope.row.status===1">正常</el-tag>
                        <el-tag type="danger" v-else>停用</el-tag>
                    </template>
                </el-table-column>
                <el-table-column prop="createTime" label="创建时间" align="center"></el-table-column>
                <el-table-column label="操作" align="center">
                    <template slot-scope="scope">
                        <el-button type="text" size="small" icon="el-icon-plus" @click="handleAdd(scope.row)"
                                   v-if="scope.row.type === 'D' || scope.row.type === 'P'">新增
                        </el-button>
                        <el-button type="text" size="small" icon="el-icon-edit" @click="handleUpdate(scope.row)">编辑</el-button>
                        <el-button type="text" size="small" icon="el-icon-delete" @click="handleDelete(scope.row)">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </el-card>

        <!-- 菜单信息对话框 -->
        <el-dialog
            :title="menuTitle"
            :modal-append-to-body="true"
            :append-to-body="true"
            :close-on-click-modal="false"
            :visible="menuVisible"
            :before-close="handleClose">
            <div class="menu-wrapper">
                <el-form ref="menuForm" :model="formData" :rules="rules" label-width="100px" label-position="right" size="small">
                    <el-row :gutter="20" class="form-row">
                        <el-col :span="24">
                            <el-form-item label="上级菜单" prop="parentId">
                                <!-- 使用自定义的 TreeSelect 组件 -->
                                <TreeSelect
                                    v-model="formData.parentId"
                                    :data="selectData"
                                    :defaultExpandAll="true"
                                    :props="{label: 'name', value: 'id', children: 'children'}"
                                    placeholder="选择父级菜单"
                                />
                            </el-form-item>
                        </el-col>
                        <el-col :span="24">
                            <el-form-item label="菜单类型" prop="type">
                                <el-radio-group v-model="formData.type">
                                    <el-radio label="D">目录</el-radio>
                                    <el-radio label="P">菜单</el-radio>
                                    <el-radio label="B">按钮</el-radio>
                                </el-radio-group>
                            </el-form-item>
                        </el-col>
                        <el-col :span="24">
                            <el-form-item label="菜单图标" prop="icon">
                                <el-popover placement="bottom-start" width="460" trigger="click" @show="$refs['iconSelect'].reset()">
                                    <IconSelect ref="iconSelect" @selectIcon="selectIcon" :active-icon="formData.icon"/>
                                    <el-input slot="reference" v-model="formData.icon" placeholder="点击选择图标" readonly>
                                        <svg-icon v-if="formData.icon" slot="prefix" :icon="formData.icon" style="width: 25px;"/>
                                        <i v-else slot="prefix" class="el-icon-search el-input__icon"></i>
                                    </el-input>
                                </el-popover>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="菜单名称" prop="name">
                                <el-input v-model="formData.name" placeholder="请输入菜单名称"/>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="显示排序" prop="sort">
                                <el-input-number v-model="formData.sort" controls-position="right" :min="0"/>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12" v-if="formData.type === 'P'">
                            <el-form-item prop="activeMenu">
                <span slot="label">
                  <el-tooltip
                      content="当前组件路由对应的菜单，如访问路由：`/system-content/dict-data/test_dict_type` 时，默认激活的菜单路由为`/system/dict-type`"
                      placement="top">
                    <i class="el-icon-question"></i>
                  </el-tooltip>
                  激活菜单
                </span>
                                <el-input v-model="formData.activeMenu" placeholder="请输入激活菜单路由"/>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item prop="path">
                <span slot="label">
                  <el-tooltip content="访问的路由地址，如：`user`，如外网地址需内链访问则以`http(s)://`开头" placement="top">
                    <i class="el-icon-question"></i>
                  </el-tooltip>
                  路由地址
                </span>
                                <el-input v-model="formData.path" placeholder="请输入路由地址"/>
                            </el-form-item>
                        </el-col>
                        <el-col :span="24" v-if="formData.type === 'P'">
                            <el-form-item prop="component">
                <span slot="label">
                  <el-tooltip content="访问的组件路径，如：`system/user/index`，默认在`views`目录下" placement="top">
                    <i class="el-icon-question"></i>
                  </el-tooltip>
                  组件路径
                </span>
                                <el-input v-model="formData.component" placeholder="请输入组件路径"/>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item prop="isFrame">
                <span slot="label">
                  <el-tooltip content="选择是外链则路由地址需要以`http(s)://`开头" placement="top">
                  <i class="el-icon-question"></i>
                  </el-tooltip>
                  是否外链
                </span>
                                <el-radio-group v-model="formData.isLink">
                                    <el-radio :label="1">是</el-radio>
                                    <el-radio :label="0">否</el-radio>
                                </el-radio-group>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12" v-if="formData.type === 'P'">
                            <el-form-item prop="isCache">
                <span slot="label">
                  <el-tooltip content="选择是则会被`keep-alive`缓存，需要匹配组件的`name`和地址保持一致" placement="top">
                  <i class="el-icon-question"></i>
                  </el-tooltip>
                  是否缓存
                </span>
                                <el-radio-group v-model="formData.isCache">
                                    <el-radio :label="1">不缓存</el-radio>
                                    <el-radio :label="0">缓存</el-radio>
                                </el-radio-group>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item prop="visible">
                <span slot="label">
                  <el-tooltip content="选择隐藏则路由将不会出现在侧边栏，但仍然可以访问" placement="top">
                  <i class="el-icon-question"></i>
                  </el-tooltip>
                  显示状态
                </span>
                                <el-radio-group v-model="formData.visible">
                                    <el-radio :label="0">显示</el-radio>
                                    <el-radio :label="1">隐藏</el-radio>
                                </el-radio-group>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item prop="status">
                <span slot="label">
                  <el-tooltip content="选择停用则路由将不会出现在侧边栏，也不能被访问" placement="top">
                  <i class="el-icon-question"></i>
                  </el-tooltip>
                  菜单状态
                </span>
                                <el-radio-group v-model="formData.status">
                                    <el-radio :label="1">正常</el-radio>
                                    <el-radio :label="0">停用</el-radio>
                                </el-radio-group>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>
            </div>
            <div slot="footer">
                <el-button type="danger" :loading="buttonLoading" @click="handleClose()" size="small" icon="el-icon-error">
                    取消
                </el-button>
                <el-button type="success" :loading="buttonLoading" @click="submitForm()" size="small" icon="el-icon-success">
                    保存
                </el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import RightToolbar from '../../../components/RightToolbar/index'
import IconSelect from '../../../components/IconSelect/index'
import {deleteMenu, reqListMenu, reqInsertMenu, reqUpdateMenu} from '../../../api/system/menu'
import TreeSelect from "@/components/tree/TreeSelect.vue";

export default {
    name: 'Menu',
    components: {TreeSelect, RightToolbar, IconSelect},
    async created() {
        // 查询表格数据
        await this.load()
    },
    methods: {
        // 获取表格数据
        async load() {
            // 开启加载框
            this.loading = true
            this.tableData = [];
            let data = await reqListMenu(this.queryParams);
            // 赋值数据参数
            this.tableData = data.records;
            this.selectData=JSON.parse(JSON.stringify(data.records))
            // 关闭等待框
            this.loading = false
        },
        toggleAdvanced() {
            this.advanced = !this.advanced
        },
        // 点击查询按钮
        async btnSearch() {
            this.queryParams.currentPage = 1
            await this.load()
        },
        // 点击重置按钮
        async btnReset() {
            this.queryParams = {currentPage: 1, pageSize: 10};
            await this.load();
        },
        // 打开菜单信息对话框
        handleOpen() {
            // 清除表单数据
            this.reset()
            this.menuVisible = true
        },
        // 关闭菜单对话框表单
        handleClose() {
            this.reset()
            this.menuVisible = false
        },
        // 点击新增按钮
        handleAdd(row) {
            this.menuTitle = '新增菜单'
            this.handleOpen()
            if (row) {
                this.formData.parentId = row.id;
                //如果当前级别为目录，则数据不动
                if (row.type==='D'){
                }else{
                    this.formData.parentId = row.id;
                }
            }
        },
        // 点击编辑按钮
        handleUpdate(row) {
            // 修改对话框标题
            this.menuTitle = '更新菜单'
            // 先取默认值再覆盖行数据，确保所有字段（包括icon）都存在，避免Vue 2无法追踪新增属性
            this.formData = { ...this.formData, ...JSON.parse(JSON.stringify(row)) }
            this.menuVisible = true
        },
        // 点击删除事件
        handleDelete(row) {
            const that = this
            this.$confirm('是否确认删除选中的菜单数据？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                that.buttonLoading = true
                that.loading = true
                deleteMenu(row.id).then((res) => {
                    that.buttonLoading = false
                    that.$message.success('删除成功')
                    // 刷新数据
                    that.load()
                }).catch(() => {
                    // 确保加载框会关闭
                    that.buttonLoading = false
                    that.loading = false
                })
            }).catch(() => {
            })
        },
        // 提交表单
        submitForm() {
            const that = this
            this.$refs.menuForm.validate(async valid => {
                // 校验未通过则直接返回
                if (!valid) return
                // 开启加载框
                that.buttonLoading = true
                that.menuLoading = true
                // 提交表单
                if (that.formData.id) {
                    await reqUpdateMenu(this.formData)
                } else {
                    await reqInsertMenu(this.formData)
                }
                this.$message.success("操作成功！");
                // 刷新表单数据并关闭对话框
                that.handleClose()
                // 刷新菜单数据
                await that.load()
                // 关闭加载框
                that.buttonLoading = false
                that.menuLoading = false
            })
        },
        // 重置表单
        reset() {
            // 清除校验条件
            const currentIcon = this.formData.icon || undefined;
            this.formData = {
                // 菜单ID
                id: undefined,
                // 菜单名称
                name: undefined,
                // 父菜单
                parentId: '0',
                // 访问路径
                path: undefined,
                // 菜单类型
                type: 'D',
                // 组件路径
                component: undefined,
                // 激活菜单
                activeMenu: undefined,
                // 是否缓存
                isCache: 0,
                // 是否外链
                isLink: 0,
                // 是否隐藏
                visible: 0,
                // 图标
                icon: currentIcon,  // 保留当前图标或初始化为undefined
                // 排序
                sort: 0,
                // 菜单状态
                status: 1
            }
            // 清除表单校验规则
            this.resetForm('menuForm')
        },
        // 选择图标
        selectIcon(name) {
            this.formData.icon = name
        }
    },
    data() {
        return {
            // 高级搜索 展开/关闭
            advanced: false,
            // 是否展示搜索内容
            showSearch: true,
            // 数据总条数
            total: 0,
            // 菜单对话框是否显示
            menuVisible: false,
            // 数据表格等待框
            loading: false,
            // 查询参数
            queryParams: {
                // 菜单名称
                name: undefined,
                // 菜单状态
                status: undefined,
                // 时间范围
                dataRange: [],
                currentPage: 1,
                pageSize: 10,
            },
            // 是否展开，默认全部折叠
            isExpandAll: false,
            // 重新渲染表格状态
            refreshTable: true,
            // 菜单表单对象
            formData: {
                // 菜单ID
                id: undefined,
                // 菜单名称
                name: undefined,
                // 父菜单
                parentId: undefined,
                // 访问路径
                path: undefined,
                // 菜单类型
                type: 'D',
                // 激活菜单
                activeMenu: undefined,
                // 组件路径
                component: undefined,
                // 是否缓存
                isCache: false,
                // 是否外链
                isLink: false,
                // 是否隐藏
                visible: false,
                // 图标
                icon: undefined,
                // 排序
                sort: 0,
                // 菜单状态
                status: true
            },
            // 菜单表单校验规则
            rules: {
                // 菜单名称
                name: [{required: true, message: '菜单名称不能为空', trigger: 'blur'}],
                // 排序
                sort: [{required: true, message: '菜单顺序不能为空', trigger: 'blur'}],
                // 访问路径
                path: [{required: true, message: '路由地址不能为空', trigger: 'blur'}]
            },
            // 菜单对话框等待框
            menuLoading: false,
            // 对话框按钮等待框
            buttonLoading: false,
            // 表格数据
            tableData: [],
            selectData:[],
            selectData2:[],
            // 对话框标题
            menuTitle: '',
            // 菜单选项
            menuOptions: [],
            menuTreeProps:{
                children: 'children',
                label: 'name'
            }
        }
    },
}

</script>

<style lang="scss" scoped>
.menu-wrapper {
    padding: 10px 30px;
}

.form-row {
    display: flex;
    flex-wrap: wrap;
}

</style>
